import { AnalyticsEventName } from '@dupe/common/constants'
import { CameraIcon, PhotoIcon } from '@heroicons/react/24/solid'
import React, { Dispatch, SetStateAction } from 'react'
import RestyleDialog from '~/src/components/restyle/RestyleDialog'
import SparklesIcon from '~/src/components/svg/SparklesIcon'
import { Badge } from '~/src/components/ui/badge'
import { DialogTrigger } from '~/src/components/ui/dialog'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/src/components/ui/dropdown-menu'
import useAnalytics from '~/src/hooks/useAnalytics'

interface Props extends React.PropsWithChildren {
  dropdownOpen: boolean
  disabled?: boolean
  hideRoomRestyle?: boolean
  setDropdownOpen: Dispatch<SetStateAction<boolean>>
  onUploadImage: () => void
  onCameraPress: () => void
  openImagePicker: ({
    source,
  }: {
    source?: 'dupe-input-camera' | 'dupe-input-upload' | 'dupe-input-restyle'
  }) => void
}

const RestyleDropDownMenu: React.FC<Props> = ({
  children,
  dropdownOpen,
  disabled,
  hideRoomRestyle,
  setDropdownOpen,
  onUploadImage,
  onCameraPress,
  openImagePicker,
}) => {
  const analytics = useAnalytics()

  return (
    <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
      <DropdownMenuTrigger
        disabled={disabled}
        asChild
        onClick={() => {
          analytics.track(
            AnalyticsEventName.ClickedInputMediaMenu,
            {},
            {
              sendToPlausible: true,
              sendToFb: true,
            }
          )
        }}
      >
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' className='w-auto min-w-64'>
        <DropdownMenuItem onClick={onUploadImage} icon={<PhotoIcon />}>
          Upload Image
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onCameraPress}
          icon={<CameraIcon />}
          className='md:hidden'
        >
          Take Photo
        </DropdownMenuItem>
        {!hideRoomRestyle && (
          <RestyleDialog
            openImagePicker={openImagePicker}
            setDropdownOpen={setDropdownOpen}
          >
            <DropdownMenuItem
              className='group font-medium'
              onClick={(e) => e.preventDefault()}
              icon={<SparklesIcon className='size-4' />}
            >
              <DialogTrigger
                className='flex items-center gap-2'
                onClick={() => {
                  analytics.track(AnalyticsEventName.RestyleInputMenuCTA)
                }}
              >
                <span className='text-[#B14CE7] transition-colors'>
                  Restyle room
                </span>
                <Badge variant='blue'>New</Badge>
              </DialogTrigger>
            </DropdownMenuItem>
          </RestyleDialog>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default RestyleDropDownMenu
